// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { EventKey, EventKeyT } from "../mce/event-key";
import { Origin } from "../mce/origin";
import { Template, TemplateT, verifyTemplate } from "../mce/template";

/**
 * One event row as the editor shows it.
 */
export class MceEventClassRow implements flatbuffers.IUnpackableObject<MceEventClassRowT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MceEventClassRow {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMceEventClassRow(
    bb: flatbuffers.ByteBuffer,
    obj?: MceEventClassRow,
  ): MceEventClassRow {
    return (obj || new MceEventClassRow()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMceEventClassRow(
    bb: flatbuffers.ByteBuffer,
    obj?: MceEventClassRow,
  ): MceEventClassRow {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MceEventClassRow()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  key(obj?: EventKey): EventKey | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? (obj || new EventKey()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  text(): string | null;
  text(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  text(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  origin(): Origin {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Origin.Unmapped;
  }

  /**
   * The template the row emits now. Absent for an ignored or transform row.
   */
  effective(obj?: Template): Template | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Template()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * The template a reset returns to. Absent when no profile row matches.
   */
  profile(obj?: Template): Template | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new Template()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  note(): string | null;
  note(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  note(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startMceEventClassRow(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, keyOffset, 0);
  }

  static addText(builder: flatbuffers.Builder, textOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, textOffset, 0);
  }

  static addOrigin(builder: flatbuffers.Builder, origin: Origin) {
    builder.addFieldInt8(2, origin, Origin.Unmapped);
  }

  static addEffective(builder: flatbuffers.Builder, effectiveOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, effectiveOffset, 0);
  }

  static addProfile(builder: flatbuffers.Builder, profileOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, profileOffset, 0);
  }

  static addNote(builder: flatbuffers.Builder, noteOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, noteOffset, 0);
  }

  static endMceEventClassRow(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // key
    return offset;
  }

  unpack(): MceEventClassRowT {
    return new MceEventClassRowT(
      this.key() !== null ? this.key()!.unpack() : null,
      this.text(),
      this.origin(),
      this.effective() !== null ? this.effective()!.unpack() : null,
      this.profile() !== null ? this.profile()!.unpack() : null,
      this.note(),
    );
  }

  unpackTo(_o: MceEventClassRowT): void {
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.text = this.text();
    _o.origin = this.origin();
    _o.effective = this.effective() !== null ? this.effective()!.unpack() : null;
    _o.profile = this.profile() !== null ? this.profile()!.unpack() : null;
    _o.note = this.note();
  }

  unpackFields(...fields: string[]): MceEventClassRowT {
    const t = new MceEventClassRowT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key() !== null ? this.key()!.unpack() : null;
    }
    if (fieldSet.has("text")) {
      t.text = this.text();
    }
    if (fieldSet.has("origin")) {
      t.origin = this.origin();
    }
    if (fieldSet.has("effective")) {
      t.effective = this.effective() !== null ? this.effective()!.unpack() : null;
    }
    if (fieldSet.has("profile")) {
      t.profile = this.profile() !== null ? this.profile()!.unpack() : null;
    }
    if (fieldSet.has("note")) {
      t.note = this.note();
    }
    return t;
  }
}

export class MceEventClassRowT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: EventKeyT | null = null,
    public text: string | Uint8Array | null = null,
    public origin: Origin = Origin.Unmapped,
    public effective: TemplateT | null = null,
    public profile: TemplateT | null = null,
    public note: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.key === null || this.key === undefined) {
      throw new Error('Required field "key" is not set');
    }
    const text = this.text !== null ? builder.createString(this.text!) : 0;
    const effective = this.effective !== null ? this.effective!.pack(builder) : 0;
    const profile = this.profile !== null ? this.profile!.pack(builder) : 0;
    const note = this.note !== null ? builder.createString(this.note!) : 0;

    MceEventClassRow.startMceEventClassRow(builder);
    MceEventClassRow.addKey(builder, this.key !== null ? this.key!.pack(builder) : 0);
    MceEventClassRow.addText(builder, text);
    MceEventClassRow.addOrigin(builder, this.origin);
    MceEventClassRow.addEffective(builder, effective);
    MceEventClassRow.addProfile(builder, profile);
    MceEventClassRow.addNote(builder, note);

    return MceEventClassRow.endMceEventClassRow(builder);
  }

  clone(): MceEventClassRowT {
    const obj = new MceEventClassRowT();
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.text = this.text;
    obj.origin = this.origin;
    obj.effective = this.effective !== null ? this.effective!.clone() : null;
    obj.profile = this.profile !== null ? this.profile!.clone() : null;
    obj.note = this.note;
    return obj;
  }

  equals(other: MceEventClassRowT): boolean {
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.text !== other.text) return false;
    if (this.origin !== other.origin) return false;
    if (this.effective !== null && other.effective !== null) {
      if (!this.effective!.equals(other.effective!)) return false;
    } else if (this.effective !== other.effective) return false;
    if (this.profile !== null && other.profile !== null) {
      if (!this.profile!.equals(other.profile!)) return false;
    } else if (this.profile !== other.profile) return false;
    if (this.note !== other.note) return false;
    return true;
  }
}

export function verifyMceEventClassRow(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
    verifier.checkRequiredField(tablePos, 4, "key");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 8, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyTemplate(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 12);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyTemplate(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
